import { AlertModal } from './AlertModal';
import { ChangePasswordModal } from './ChangePasswordModal';
import { ConfirmationModal } from './ConfirmationModal';
import { CreateApiKey } from './CreateApiKey';
import { DateRange } from './date-range/DateRange';
import { EditNoteModal } from './EditNoteModal';
import FeatureFlagsModal from './FeatureFlagsModal';
import { NewDeviceWidgets } from './features-notifications/features-modals/NewDeviceWidgets';
import { FeaturesNotifications } from './features-notifications/FeaturesNotifications';
import filtersModals from './filters';
import { RetryChargeFailureModal } from './Invoice/RetryChargeFailureModal';
import { RetryChargeSuccessModal } from './Invoice/RetryChargeSuccessModal';
import { RegisteredWithDifferentPortal } from './RegisteredWithDifferentPortal';
import { ReplaceDevice } from './ReplaceDevice';
import ShowHash from './ShowHash';
import { SwitchTenant } from './SwitchTenant';
import { TextEditorModal } from './text-editor/TextEditorModal';
import { UploadFile } from './UploadFile';
import { UploadImageModal } from './UploadImageModal/UploadImageModal';

const MODALS = {
  ChangePasswordModal,
  ShowHash,
  ConfirmationModal,
  FeatureFlagsModal,
  UploadImageModal,
  SwitchTenant,
  UploadFile,
  DateRange,
  TextEditorModal,
  CreateApiKey,
  ReplaceDevice,
  FeaturesNotifications,
  EditNoteModal,
  NewDeviceWidgets,
  AlertModal,
  RegisteredWithDifferentPortal,
  RetryChargeSuccessModal,
  RetryChargeFailureModal,
  ...filtersModals,
};

export { type UploadFileProps } from './UploadFile';
export type { FeatureFlagsModalProps } from './FeatureFlagsModal';
export { type DateRangeProps } from './date-range/DateRange';
export { type TextEditorModalProps } from './text-editor/TextEditorModal';
export { type DateRangeType } from './date-range/types';
export { type CreateApiKeyProps } from './CreateApiKey';
export { type ReplaceDeviceProps } from './ReplaceDevice';
export { type FeaturesNotificationsProps } from './features-notifications/FeaturesNotifications';
export { type NewDeviceWidgetsProps } from './features-notifications/features-modals/NewDeviceWidgets';
export { type EditNoteModalProps } from './EditNoteModal';
export { type UploadImageModalProps } from './UploadImageModal/UploadImageModal';
export { type AlertModalProps } from './AlertModal';
export { type ConfirmationModalProps } from './ConfirmationModal';
export { type RegisteredWithDifferentPortalModalProps } from './RegisteredWithDifferentPortal';

export default MODALS;
